import SingleCheckboxFilter from './SingleCheckboxFilter';
export type { SingleCheckboxFilterProps } from './SingleCheckboxFilterProps.types';

export default SingleCheckboxFilter;
